import { OrderAttachmentType } from './OrderAttachmentType';
export class OrderAttachment {
    /**
     * Map order attachments to job attachments
     */
    static mapToJobAttachments(attachments, jobId) {
        return attachments.map(attachment => ({
            jobId,
            id: attachment.id,
            fileId: attachment.fileId,
            type: attachment.type,
        }));
    }
    /**
     * Return cost waiver documents only
     */
    static getCostWaiverDocuments(attachments) {
        return attachments.filter(attachment => attachment.type === OrderAttachmentType.CostWaiverDocument);
    }
    /**
     * Return supporting documents only
     */
    static getSupportingDocuments(attachments) {
        return attachments.filter(attachment => attachment.type === OrderAttachmentType.SupportingDocument);
    }
}
